import { render, staticRenderFns } from "./mail-icon.vue?vue&type=template&id=96a4ad1c&"
import script from "./mail-icon.vue?vue&type=script&lang=js&"
export * from "./mail-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports